import { useQuery } from "react-query";
import { getStoreList } from "../ApiService";
import PageContainer from "../components/PageContainer/PageContainer";
import StoreSelect from "../modules/StoreSelect/StoreSelect";
import Button from "../components/Button/Button";
import { useState } from "react";
import CreateStoreModule from "../modules/CreateStoreModule/CreateStoreModule";
import PageBlock from "../components/PageContainer/PageBlock";
import { useMarketplace } from "../contexts/MarketplaceContext";

export default function StoreListPage() {
  const { currentMarketplace, isWB, isOzon } = useMarketplace();
  const { data: stores } = useQuery(
    ["stores", currentMarketplace],
    () => getStoreList(currentMarketplace)
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCreateStore = () => {
    setIsModalOpen(true);
  };

  const marketplaceName = isWB ? "Wildberries" : "Ozon";

  return (
    <PageContainer>
      <PageBlock>
        <div className="h2Font">
          Ваши магазины {marketplaceName}
        </div>
        <StoreSelect stores={stores} />
        <Button title="Создание магазина" onClick={handleCreateStore} />
      </PageBlock>
      <CreateStoreModule
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </PageContainer>
  );
}
